import React, {useState} from 'react';

//Components
import {ChevronRight} from "react-feather";
import Flag from '../../Flag/Flag';



//Hooks
import { useTranslation } from 'react-i18next';

//Styles
import Styles from './LanguageInput.module.scss';

//Utils
import PropTypes from 'prop-types';


const Language = ({value, locales, languageHandler}) => {
    const [toggle, setToggle] = useState(false)
    const {t} = useTranslation('common')

    return (
        <div className={Styles.container}>
            <label className={Styles.label}>
                    {t('myProfile.settings.language')}
            </label> 
            <div className={Styles.inputContainer}>
                <ChevronRight className={[Styles.chevron, toggle ? Styles.toggle : ''].join(' ')} size={22}/>
                <div className={Styles.customSelect} style={{borderBottom: toggle ? '1px solid var(--tint-color)' : ''}}>
                    <Flag name={value} size={25}/>
                    <input value ={locales.find(o => o.code === value).name} onClick={() => setToggle(!toggle)} type='button'/>
                </div>
                    {
                        toggle ?
                        <div className={Styles.optionContainer}>
                            {
                                locales.map(local => (
                                <option
                                    key={local.code}
                                    onClick={()=>{
                                            languageHandler(local.code)
                                            setToggle(!toggle)
                                    }}
                                        value={local.code}
                                    >
                                    {local.name}
                                </option>
                                )) 
                            }
                        </div> :
                        null
                    }
            </div>
        </div>
    );
};

Language.propTypes = {
    languageHandler: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    locales: PropTypes.array.isRequired
};

export default Language
